import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({

  select: {
    marginTop: '8px',
    marginBottom: '4px',
    color:'black',
  },

  formLine: {
    gap: '12px',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
  },
  selectFullLine: {
    width: '100%',
  },
  formLineTwo: {
    width: '100%',
    textAlign: 'left',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '12px',
    [theme.breakpoints.down('500')]: {
      '& > *': {
        width: '100%',
        marginRight: '0'
      }
    }
  },

  cityLine: {
    textAlign: 'left',

    '& > *:first-child': {
      marginRight: '8px',
      width: '100%',
      '& > *:first-child > div': {
        padding: '1px',
        paddingLeft: '8px',
        marginTop: '8px',
        marginBottom: '4px'
      }
    },
    '& > *:last-child': {
      width: '130px',
      '& > *': {
        width: '100%'
      },
    },
    [theme.breakpoints.up('400')]: {
      '& > *': {
        display: 'inline-block',
      },
      '& > *:first-child': {
        width: 'calc(100% - 138px)',
      }
    },
    '& ul': {
      boxSizing: 'border-box',
      padding: 0,
      margin: 0,
    },
    '& .MuiAutocomplete-root .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      transform: 'translate(18px, 0px) scale(0.75)',
    }
  },

}))



export const useStylesAutoComplete = makeStyles({
  listbox: {
    boxSizing: 'border-box',
    '& ul': {
      padding: 0,
      margin: 0
    }
  }
})
